module.exports = __webpack_public_path__ + "media/images/lasvegas_01_wide-249e723982494302fc3f5e8759d84141.jpg";